import React from 'react';
import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const WhyUsHero = ({ data }) => {
  return (
    <Box
      minH="90vh"
      bgGradient="linear(to-br, brand.700, brand.900, accent.green)"
      position="relative"
      overflow="hidden"
    >
      {/* Blur effects */}
      <Box
        position="absolute"
        top="10%"
        right="10%"
        w="300px"
        h="300px"
        bg="accent.gold"
        opacity="0.1"
        borderRadius="full"
        filter="blur(80px)"
      />
      <Box
        position="absolute"
        bottom="20%"
        left="5%"
        w="400px"
        h="400px"
        bg="accent.green"
        opacity="0.15"
        borderRadius="full"
        filter="blur(100px)"
      />

      <Container maxW="container.xl" pt={{ base: 32, md: 40 }} pb={20}>
        <MotionBox
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <VStack spacing={6} align="center" textAlign="center">
            <Heading
              as="h1"
              fontSize={{ base: '4xl', md: '5xl', lg: '6xl' }}
              fontWeight="900"
              color="white"
              lineHeight="1.1"
            >
              {data.title}
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color="whiteAlpha.900"
              maxW="3xl"
            >
              {data.subtitle}
            </Text>
          </VStack>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default WhyUsHero;